import { useEffect, useState } from 'react';
import type { NewsArticlePage } from '../Types';
import { NewsArchiveFilter, type NewsArchiveFilterState } from './NewsArchiveFilter';
import { NewsArchiveList } from './NewsArchiveList';

export interface INewsArchivePageProps {
    years: string[];
    region: string;
    selectedYear: string;
    selectedMonth: string;
}

export const NewsArchivePage: React.FC<INewsArchivePageProps> = (props) => {
    const [items, setItems] = useState<NewsArticlePage[]>([]);
    const [year, setYear] = useState<string>(null);
    const [month, setMonth] = useState<string>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const onFilterChange = (data: NewsArchiveFilterState) => {
        const newYear = data.year ?? year;
        const newMonth = data.month ?? month;
        setYear(newYear);
        setMonth(newMonth);

        if (history !== undefined && history !== null) {
            history.replaceState({ year: newYear, month: newMonth }, 'FilterState');
        }
    };

    useEffect(() => {
        setLoading(true);
        if (year === null) {
            setYear(history.state?.year ?? props.selectedYear);
        }
        if (month === null) {
            setMonth(history.state?.month ?? props.selectedMonth ?? '0');
        }
        const abortController = new AbortController();

        const fetchData = async () => {
            try {
                const response = await fetch(
                    `/api/newsarchive/action/newsbyyear?region=${props.region}&year=${year}${month !== '0' ? `&month=${month}` : ''}`,
                    {
                        signal: abortController.signal,
                    },
                );
                const news = await response.json();
                setItems(news);
                setLoading(false);
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.log('Could not fetch news articles: ' + error.message);
                    setLoading(false);
                }
            }
        };

        fetchData();
        return () => {
            abortController.abort();
        };
    }, [year, month]);

    return (
        <div>
            <NewsArchiveFilter years={props.years} selectedYear={year} selectedMonth={month} disabled={year === null} onUpdate={onFilterChange} />
            {loading ? (
                <div className="text-center" role="alert" aria-busy="true">
                    Laddar...
                </div>
            ) : items.length === 0 ? (
                <p className="no-result news-archive__no-items">Det finns inga resultat att visa</p>
            ) : (
                <NewsArchiveList items={items} />
            )}
        </div>
    );
};
